module.exports = __webpack_public_path__ + "img/ellipse-bottom-left.b0b94845.png";